import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCalendarAlt, faEdit, faEye, faMagnifyingGlass, faTrash } from '@fortawesome/free-solid-svg-icons'
import { useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { deleteMemberDetail, getAddType, getMemberList, getProvider, memberTypeData } from '../../Redux/Actions/DashOptions'
import { capitalizeFirstLetter, constructOptions } from '../../Utils/helper'
import { toast } from 'react-toastify'
import Select from 'react-select'
import { debounce } from 'lodash'
import { Circles } from 'react-loader-spinner'
import AlertDialogSlide from '../../Common/DeleteDialog'
import Pagination from '../../Common/Pagination'
import Loader from '../../Common/Loader'
import axios from 'axios'
import Uploadmember from './UploadMember'

const MemberListing = () => {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const getMemberData = useSelector((state) => state?.DashOptionsSlice?.memberList?.data) // get member data
    const getListLoading = useSelector((state) => state?.DashOptionsSlice?.isLoading)       // get member list loading
    const getSearchedData = useSelector((state) => state?.DashOptionsSlice?.memberSearchedData?.data)    // get lisitng loading
    const searchedDataLoading = useSelector((state) => state?.DashOptionsSlice?.isLoading)    // get lisitng loading
    const [selectedFile, setSelectedFile] = useState(null); // State to handle selected file
    const [isOpen, setIsOpen] = useState(false)
    const onClose = () => {setIsOpen(false)}
    const { current_page, last_page, from, to, total } = useSelector((state) => state?.DashOptionsSlice?.memberList || {}); // getting pagination
    const searchPaginationData = useSelector((state) => state?.DashOptionsSlice?.memberSearchedData || {}); // getting pagination


    const getProviderData = useSelector((state) => state?.DashOptionsSlice?.listdata?.data) // get data for provider filter
    const getDataType = useSelector((state) => state?.DashOptionsSlice?.getTypeData?.data)

    const [open, setOpen] = React.useState(false);
    const [page, setPage] = useState(current_page || 1);
    const [deleteID, setDeleteID] = useState()
    const [searchValue, setSearchValue] = useState('')
    const [isFiltering, setIsFiltering] = useState(false);
    const [filters, setFilters] = useState({
        provider: null,
        status: null,
        type: null,
    });


    const handleDelete = (selectedID) => {
        setOpen(true)
        setDeleteID(selectedID)
    }

    const handleViewDetail = (id) => {
        navigate(`/dashboard/viewmemberdetail/${id}`)
    }
    const handleEdit = (id) => {
        navigate(`/dashboard/addmember/${id}`)
    }

    const handlePageChange = (event, value) => {
        setPage(value);
    };

    const handleDeleteByModal = () => {
        dispatch(deleteMemberDetail(deleteID)).then((res) => {
            if (res?.payload) {
                toast.success(res?.payload?.message)
                setOpen(false);
                dispatch(getMemberList({ page: page }))
            } else {
                toast.error('An error occured')
            }
        })
    }
    const options = [
        { value: 'active', label: 'Active' },
        { value: 'inactive', label: 'Inactive' },
    ]
    const handleFilterChange = (key, selectedValue) => {
        const updatedFilters = {
            ...filters,
            [key]: selectedValue,
        };
        setFilters(updatedFilters);
        setIsFiltering(true);

        // Build payload only with selected filters
        const payload = {
            ...(updatedFilters.provider && { provider: updatedFilters.provider.value }),
            ...(updatedFilters.status && { status: updatedFilters.status.value }),
            ...(updatedFilters.type && { type: updatedFilters.type.value }),
        };

        dispatch(memberTypeData(payload));
    };

    const debouncedSearch = useMemo(() => debounce((query) => {
        if (query.trim() === "") {
            dispatch(memberTypeData({ field: "", value: "" }));
            dispatch(getMemberList({ page: page }));
            setPage(current_page || 1);
        } else {
            setPage(searchPaginationData?.current_page || 1)
            dispatch(memberTypeData({ name: query }));
        }
    }, 500), [dispatch]);


    const handleSearch = useCallback((e) => {
        const value = e.target.value;
        setSearchValue(value);
        debouncedSearch(value);
    }, [debouncedSearch]);
     // New function: Handles { file } from modal (replaces handleFileUpload)
const handleModalSubmit = async ({ file }) => {
    // Safeguard: Check if file exists and is valid
    if (!file || !file.name) {
        toast.error('No valid file selected.');
        return;
    }

    setSelectedFile(file); // Optional: Set state if needed elsewhere

    const formData = new FormData();
    formData.append("csv_file", file); // Use the passed file directly

    try {
        const response = await axios.post(
            `${process.env.REACT_APP_LARAVEL_API_URL}/upload-members`,
            formData,
            {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            }
        );
        
        console.log("Response:", response.data);
        toast.success('File uploaded successfully!'); // Or use response.data.message if available
        setIsOpen(false); // Close modal on success
        setSelectedFile(null); // Reset state
        // Optional: Refresh member list after upload
        dispatch(getMemberList({ page: page }));
    } catch (error) {
        console.error("Upload error:", error);
        toast.error('Upload failed. Please try again.'); // Or error.response?.data?.message
    }
};
    
    const isSearching = useMemo(() => searchValue.trim() !== "", [searchValue]);
    const showSearchedData = isSearching || isFiltering;

    const handleClearfilters = () => {
        setSearchValue('');
        setIsFiltering(false);
        setFilters({ provider: "", type: "", status: "" })
        dispatch(getMemberList({ page: page }));
    }
    useEffect(() => {
        const payload = {
            page,
            ...(filters.provider && { provider: filters.provider.value }),
            ...(filters.status && { status: filters.status.value }),
            ...(filters.type && { type: filters.type.value }),
        };

        if (filters.provider || filters.status || filters.type || isSearching) {
            dispatch(memberTypeData(payload));
        } else {
            dispatch(getMemberList({ page }));
        }

        dispatch(getProvider());
        dispatch(getAddType());
    }, [page, filters, isSearching]);
    return (
        <div>
            <section className=" mx-auto px-2 py-2">
                {!isSearching && getListLoading && (<Loader />)}
                <div className="bg-white rounded-xl shadow-md overflow-hidden">
                    <div className="px-6 pt-4 pb-0 flex justify-between items-center">
                        <h2 className="text-lg font-semibold text-gray-800">Member Details</h2>
                        
                                                <div className="flex items-center gap-2">
    {/* Commented out inline file upload (uncomment if needed later) */}
    {/* <input
        type="file"
        id="file-upload"
        onChange={handleFileUpload}
        className="hidden"
        accept=".pdf,.doc,.docx,.jpg,.jpeg,.png,.csv"
    /> */}
    {/* <label
        htmlFor="file-upload"
        className="px-4 py-2 bg-indigo-600 text-white rounded-md hover:bg-indigo-700 cursor-pointer transition flex items-center gap-2"
    >
        <FontAwesomeIcon icon={faCalendarAlt} className="text-sm" />
        Upload CSV
    </label> */}

    {/* Styled Blue Background Button (opens modal) */}
    <button 
        onClick={() => setIsOpen(true)}
        className="px-4 py-2 bg-indigo-600 hover:bg-indigo-700 text-white rounded-md shadow-md transition duration-300 ease-in-out flex items-center gap-2 font-medium text-sm"
    >
        <FontAwesomeIcon icon={faCalendarAlt} className="text-sm" />
        <span>Upload CSV</span>
    </button>
</div>
                                          

                    </div>
                    <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4 mx-auto px-6 py-6 bg-white mb-6 border-b border-gray-200">
                        <div className="flex flex-col sm:flex-row flex-wrap gap-4">
                            {/* Provider Dropdown */}
                            <div className="min-w-[180px]">
                                <Select
                                    placeholder="Select Provider"
                                    options={constructOptions(getProviderData?.filter(p => p?.status === 'active'), "id", "name")}
                                    className="react-select-container text-sm"
                                    classNamePrefix="react-select"
                                    onChange={(e) => handleFilterChange("provider", e)}
                                    value={filters.provider}
                                />
                            </div>
                            {/* Month Dropdown */}
                            <div className="min-w-[180px]">
                                <Select
                                    placeholder="Select Type"
                                    options={constructOptions(getDataType?.filter(p => p?.status === 'active'), "id", "name")}
                                    className="react-select-container text-sm"
                                    classNamePrefix="react-select"
                                    onChange={(e) => handleFilterChange("type", e)}
                                    value={filters.type}
                                />
                            </div>
                            <div className="min-w-[180px]">
                                <Select
                                    placeholder="Select Status"
                                    options={options}
                                    className="react-select-container text-sm"
                                    classNamePrefix="react-select"
                                    onChange={(e) => handleFilterChange("status", e)}
                                    value={filters.status}
                                />
                            </div>
                            {isFiltering && (
                                <button
                                    className="bg-gray-300 text-gray-800 px-3 py-1 rounded-lg text-sm font-medium hover:bg-gray-400"
                                    onClick={() => handleClearfilters()}
                                >
                                    Clear Filters
                                </button>
                            )}
                        </div>

                        {/* Right Section - Checkbox & Search */}
                        <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4">
                            {/* Search Field */}
                            <div className="relative w-full sm:w-64">
                                <input
                                    type="text"
                                    placeholder="Search by Name"
                                    onChange={(e) => handleSearch(e)}
                                    className="w-full bg-gray-100 border border-gray-300 rounded-lg px-4 py-2 pl-10 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                />
                                <div className="absolute inset-y-0 left-1 flex items-center pointer-events-none">
                                    <FontAwesomeIcon icon={faMagnifyingGlass} className="text-gray-400" />
                                </div>
                            </div>

                        </div>
                    </div>

                    <div className="table-container scrollbar-hide">
                        <table className="min-w-full divide-y divide-gray-200">
                            <thead className="sticky-header">
                                <tr>
                                    <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Name</th>
                                    <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Client Name</th>
                                    <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Member ID</th>
                                    <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">DOB</th>
                                    <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Provider</th>
                                    <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Type</th>
                                    <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Status</th>
                                    <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">SSN</th>
                                    {/* <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Start Date</th>
                      <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Last Cover Date</th> */}
                                    <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Actions</th>
                                </tr>
                            </thead>
                            <tbody className="bg-white divide-y divide-gray-200">
                                {searchedDataLoading && isSearching ? (
                                    <tr>
                                        <td colSpan="12" className="text-center py-6 text-gray-900">
                                            <div className="flex justify-center items-center h-40">
                                                <Circles
                                                    height="80"
                                                    width="80"
                                                    color="#2563EB"
                                                    ariaLabel="circles-loading"
                                                    visible={true}
                                                />
                                            </div>
                                        </td>
                                    </tr>
                                ) : showSearchedData ? (
                                    getSearchedData && getSearchedData?.length > 0 ? (
                                        getSearchedData?.map((item, index) => {
                                            const name = item.name || '';
                                            const nameParts = name.trim().split(' ');
                                            const initials =
                                                nameParts.length >= 2
                                                    ? `${nameParts[0][0]}${nameParts[nameParts.length - 1][0]}`
                                                    : nameParts[0][0];
                                            return (
                                                <tr className="hover:bg-gray-50" key={index}>
                                                    <td className="px-2 py-2 whitespace-nowrap">
                                                        <div className="flex items-center">
                                                            <div className="flex-shrink-0 h-10 w-10 rounded-full bg-yellow-100 flex items-center justify-center">
                                                                <span className="text-yellow-600 font-medium"> {initials.toUpperCase()}</span>
                                                            </div>
                                                            <div className="ml-4">
                                                                <div className="text-sm font-medium text-gray-900">{capitalizeFirstLetter(item?.name)}</div>
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{item?.client?.name || "--"}</td>
                                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{item?.member_id}</td>
                                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{new Date(item?.dob).toLocaleDateString('en-GB')}</td>
                                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{item?.provider?.name}</td>
                                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{item?.type?.name}</td>
                                                    <td className="px-6 py-4 whitespace-nowrap">
                                                        <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full"> <span
                                                            className={`px-3 py-1 rounded-full text-sm font-medium
                                ${item?.status === 'active'
                                                                    ? 'bg-green-100 text-green-700'
                                                                    : 'bg-red-100 text-red-700'}`}
                                                        >
                                                            {capitalizeFirstLetter(item?.status)}
                                                        </span></span>
                                                    </td>
                                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{item?.ssn}</td>
                                                    {/* <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{new Date(item?.start_date).toLocaleDateString('en-GB')}</td>
                              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{new Date(item?.last_cover_date).toLocaleDateString('en-GB')}</td> */}
                                                    <td className="px-6 py-4 whitespace-nowrap text-center text-sm font-medium flex items-center justify-center gap-2 ">
                                                        <button className="text-blue-600 hover:text-blue-900" onClick={() => handleViewDetail(item?.id)}><FontAwesomeIcon icon={faEye} className="text-blue-600" /></button>
                                                        <button className="text-blue-600 hover:text-blue-900" onClick={() => handleEdit(item?.id)}><FontAwesomeIcon icon={faEdit} className="text-blue-600" /></button>
                                                        <button className="text-red-600 hover:text-blue-900" onClick={() => handleDelete(item?.id)}><FontAwesomeIcon icon={faTrash} className="text-red-600" /></button>
                                                    </td>
                                                </tr>
                                            )
                                        })
                                    ) : (
                                        <tr>
                                            <td colSpan="12" className="text-center py-6 text-gray-900">
                                                No search results found.
                                            </td>
                                        </tr>
                                    )
                                ) : (
                                    getMemberData && getMemberData?.length > 0 ? (
                                        getMemberData && getMemberData?.map((item, index) => {
                                            const name = item.name || '';
                                            const nameParts = name.trim().split(' ');
                                            const initials =
                                                nameParts.length >= 2
                                                    ? `${nameParts[0][0]}${nameParts[nameParts.length - 1][0]}`
                                                    : nameParts[0][0];
                                            return (
                                                <tr className="hover:bg-gray-50" key={index}>
                                                    <td className="px-2 py-2 whitespace-nowrap">
                                                        <div className="flex items-center">
                                                            <div className="flex-shrink-0 h-10 w-10 rounded-full bg-yellow-100 flex items-center justify-center">
                                                                <span className="text-yellow-600 font-medium"> {initials.toUpperCase()}</span>
                                                            </div>
                                                            <div className="ml-4">
                                                                <div className="text-sm font-medium text-gray-900">{capitalizeFirstLetter(item?.name)}</div>
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{item?.client?.name || "--"}</td>
                                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{item?.member_id}</td>
                                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{new Date(item?.dob).toLocaleDateString('en-GB')}</td>
                                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{item?.provider?.name}</td>
                                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{item?.type?.name}</td>
                                                    <td className="px-6 py-4 whitespace-nowrap">
                                                        <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full"> <span
                                                            className={`px-3 py-1 rounded-full text-sm font-medium
                                ${item?.status === 'active'
                                                                    ? 'bg-green-100 text-green-700'
                                                                    : 'bg-red-100 text-red-700'}`}
                                                        >
                                                            {capitalizeFirstLetter(item?.status)}
                                                        </span></span>
                                                    </td>
                                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{item?.ssn}</td>
                                                    {/* <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{new Date(item?.start_date).toLocaleDateString('en-GB')}</td>
                              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{new Date(item?.last_cover_date).toLocaleDateString('en-GB')}</td> */}
                                                    <td className="px-6 py-4 whitespace-nowrap text-center text-sm font-medium flex items-center justify-center gap-2 ">
                                                        <button className="text-blue-600 hover:text-blue-900" onClick={() => handleViewDetail(item?.id)}><FontAwesomeIcon icon={faEye} className="text-blue-600" /></button>
                                                        <button className="text-blue-600 hover:text-blue-900" onClick={() => handleEdit(item?.id)}><FontAwesomeIcon icon={faEdit} className="text-blue-600" /></button>
                                                        <button className="text-red-600 hover:text-blue-900" onClick={() => handleDelete(item?.id)}><FontAwesomeIcon icon={faTrash} className="text-red-600" /></button>
                                                    </td>
                                                </tr>
                                            )
                                        })
                                    ) : (
                                        <tr>
                                            <td colSpan="12" className="text-center py-6 text-gray-900">
                                                No data available.
                                            </td>
                                        </tr>
                                    )
                                )}
                            </tbody>
                        </table>
                    </div>

                    {/* <!-- Pagination --> */}
                    <div className="px-6 py-4 border-t border-gray-200 flex items-center justify-between">
                        <div className="flex-1 flex justify-between sm:hidden">
                            <a href="#" className="relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50">Previous</a>
                            <a href="#" className="ml-3 relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50">Next</a>
                        </div>
                        <div className="hidden sm:flex-1 sm:flex sm:items-center sm:justify-between">
                            <div>
                                <p className="text-sm text-gray-700">
                                    Showing <span className="font-medium">{showSearchedData ? searchPaginationData?.from : from}</span> to <span className="font-medium">{showSearchedData ? searchPaginationData?.to : to}</span> of <span className="font-medium">{showSearchedData ? searchPaginationData?.total : total}</span> results
                                </p>
                            </div>
                            <div>
                                <Pagination
                                    count={!showSearchedData ? last_page : searchPaginationData?.last_page}  // total pages
                                    page={page}         // current page
                                    onPageChange={handlePageChange}  // handler
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <AlertDialogSlide open={open} setOpen={setOpen} handleDeleteByModal={handleDeleteByModal} />
            <Uploadmember  isOpen={isOpen} onClose={onClose} onSubmit={handleModalSubmit} />
            
        </div>
    )
}

export default MemberListing
